import { render, staticRenderFns } from "./MinimalHeader.vue?vue&type=template&id=0017d752&scoped=true&"
import script from "./MinimalHeader.vue?vue&type=script&lang=js&"
export * from "./MinimalHeader.vue?vue&type=script&lang=js&"
import style0 from "./MinimalHeader.vue?vue&type=style&index=0&id=0017d752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017d752",
  null
  
)

export default component.exports